import { useEffect } from "react";
import { siteConfig } from "@/config/site";

interface PageMetaProps {
  title: string;
  description: string;
  path: string;
}

/**
 * Client-side head sync for SPA navigation. The canonical/OG tags a crawler sees come
 * from the prerendered HTML (scripts/prerender.mjs) — this component keeps the live
 * DOM in sync after a client-side route change so the tab title and back/forward
 * history stay correct too.
 */
export function PageMeta({ title, description, path }: PageMetaProps) {
  useEffect(() => {
    document.title = title;

    const descriptionTag = document.querySelector('meta[name="description"]');
    descriptionTag?.setAttribute("content", description);

    let canonicalTag = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonicalTag) {
      canonicalTag = document.createElement("link");
      canonicalTag.rel = "canonical";
      document.head.appendChild(canonicalTag);
    }
    canonicalTag.href = `${siteConfig.url}${path}`;
  }, [title, description, path]);

  return null;
}
